import React, { useState, useEffect } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { format } from 'date-fns';
import { Form } from "react-bootstrap";

import {
  getdashboardData,
  // getPlanCount,
  getUsersCountfilter,
  // getWorkoutCount,
} from "../../api/Dashboard";

const Dashboard = () => {
  const [dashboardCount, setDashboardCount] = useState();
  const [filterOption, setFilterOption] = useState("month"); // Options: day, week, month, 3months, year, custom
  // States for custom date range filter
  const [startDate, setStartDate] = useState( format(new Date(), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'));

  const [usersCountf, setUsersCountF] = useState({
    newRegistrations: 0,
    totalSubscribers: 0
  });


  useEffect(() => {
    (async () => {
      try{
       const dashboardcnt  = await getdashboardData();
       setDashboardCount(dashboardcnt)
      }catch (e){
        console.log("Error :", e?.message)
      }
    })()
  },[])

  // Fetch data based on filter option and selected date or custom range
  useEffect(() => {
    const fetchData = async () => {
      try {
        const sdate = format(startDate, 'yyyy-MM-dd');
        const edate = format(endDate, 'yyyy-MM-dd');

        const params =
          filterOption === "custom"
            ? { range: filterOption, startDate :sdate, endDate:edate }
            : { range: filterOption };

        const users = await getUsersCountfilter(params);
        setUsersCountF(users);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [filterOption, startDate, endDate]);


  const handleFilterChange = (event) => {
    setFilterOption(event.target.value);
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  return (
    <div className="right-side-wrapper bg-light">
      <div className="p-4" style={{ minHeight: "100vh" }}>
        {/* Header & Filters */}
        <header className="mb-4">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <h1 className="h3 text-primary">Dashboard Overview</h1>
           
          </div>
        </header>

        <main>
          {/* User Metrics Cards */}
          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <div className="card shadow border-primary">
                <div className="card-body">
                  <h5 className="card-title">Total Users</h5>
                  <p className="card-text display-6">
                    {dashboardCount?.totalUsers || 0 }
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card shadow border-success">
                <div className="card-body">
                  <h5 className="card-title">Free Users</h5>
                  <p className="card-text display-6">
                    {dashboardCount?.totalFreeUsers || 0}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card shadow border-warning">
                <div className="card-body">
                  <h5 className="card-title">Paid Users</h5>
                  <p className="card-text display-6">
                    {dashboardCount?.totalPaidUsers || 0}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Subscribers Cards */}
          <div className="row g-4 mt-4">
            <div className="col-lg-4 col-md-6">
              <div className="card shadow border-info">
                <div className="card-body">
                  <h5 className="card-title">Total Subscribers</h5>
                  <p className="card-text display-6">
                    {dashboardCount?.totalSubscribers || 0}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card shadow border-info">
                <div className="card-body">
                  <h5 className="card-title">Monthly Subscribers</h5>
                  <p className="card-text display-6">
                    {dashboardCount?.totalMonthlySubscribers || 0}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card shadow border-info">
                <div className="card-body">
                  <h5 className="card-title">Yearly Subscribers</h5>
                  <p className="card-text display-6">
                    {dashboardCount?.totalYearlySubscribers || 0}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Demographics Section */}
          <div className="row g-4 mt-4">
           <div className="col-lg-6">
              <div className="card shadow">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">Registration &amp; Subscribers</h5>
                </div>
                <div className="card-body">
                <div className="d-flex align-items-center">
              <div className="me-3">
                <select
                  className="form-select"
                  value={filterOption}
                  onChange={handleFilterChange}
                >
                  <option value="day">Day</option>
                  <option value="week">Week</option>
                  <option value="month">Month</option>
                  <option value="3months">3 Months</option>
                  <option value="year">Year</option>
                  <option value="custom">Custom</option>
                </select>
              </div>
              {filterOption === "custom" && (
                <div className="d-flex gap-2">

                  <Form.Control
                    type="date"
                    name="trigger_time"
                    value={startDate}
                    onChange={({target}) => handleStartDateChange(target.value)}
                  />

                  <Form.Control
                    type="date"
                    name="trigger_time"
                    value={endDate}
                    onChange={({target}) => handleEndDateChange(target.value)}
                  />       
                  {/* <DatePicker 
                    selected={startDate}
                    onChange={handleStartDateChange}
                    className="form-control me-2"
                    dateFormat="yyyy-MM-dd"
                    // minDate={startDate}
                  />
                  <DatePicker
                    selected={endDate}
                    onChange={handleEndDateChange}
                    className="form-control"
                    dateFormat="yyyy-MM-dd"
                    // minDate={startDate}
                  /> */}
                </div>
              )}
            </div>
                    <div className="mb-3 mt-5">
                      <p className="mb-3 d-flex"> <h5 className="card-title">New Registration : {usersCountf?.newRegistrations}</h5></p>
                      <p className="mb-3 d-flex"><h5 className="card-title">Total Subscribers : {usersCountf?.totalSubscribers}</h5> </p>
                    </div>
                </div>
              </div>
            </div>

            {/* Age & Gender */}
            <div className="col-lg-3">
              <div className="card shadow">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">Age &amp; Gender</h5>
                </div>
                <div className="card-body">
                {Object.entries(dashboardCount?.ageGenderBased || {}).map(([ageGroup, genders],index) => {
                  return (<div key={index} className="mb-3">
                    <h6>{ageGroup}</h6>
                    <p className="mb-1">Male: {genders?.male}</p>
                    <p className="mb-1">Female: {genders?.female}</p>
                    <p className="mb-0">Other: {genders?.other}</p>
                  </div>)

                })}
                </div>
              </div>
            </div>
            {/* Geographical Location */}
            <div className="col-lg-3">
              <div className="card shadow">
                <div className="card-header bg-secondary text-white">
                  <h5 className="mb-0">Geographical Location</h5>
                </div>
                <div className="card-body">

                {Object.entries(dashboardCount?.locationBased || {}).map(([ageGroup, genders],index) => {

                  return (<div key={index} className="mb-3">
                    <h6>{ageGroup}</h6>
                    <p className="mb-0">Users: {genders}</p>
                  </div>)
                })}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
